import {PaymentCardType} from "../../../enums";
import {
  IconAch,
  IconApplePay,
  IconDiners,
  IconDiscover,
  IconGeneralCard,
  IconGooglePay,
  IconMastercard,
  IconVisa,
} from "../../bounce-ui/assets";

export const PaymentCardTypeIconMap = {
  [PaymentCardType.ACH]: <IconAch />,
  [PaymentCardType.DINERS]: <IconDiners />,
  [PaymentCardType.DISCOVER]: <IconDiscover />,
  [PaymentCardType.GENERAL_CARD]: <IconGeneralCard />,
  [PaymentCardType.MASTERCARD]: <IconMastercard />,
  [PaymentCardType.VISA]: <IconVisa />,
  [PaymentCardType.APPLE_PAY]: <IconApplePay />,
  [PaymentCardType.GOOGLE_PAY]: <IconGooglePay />,
} as const;
